import * as yup from 'yup'

const teamValidationSchema = yup.object().shape({
  name: yup.string().required('Required *'),
  objective: yup.string().required('Required *'),
  teamLead: yup.object().shape({
    name: yup.string().required('Team lead name is required'),
    image: yup.mixed().default(null).nullable(), // Use `.required()` if mandatory
  }),
  facilitators: yup.array().of(
    yup.object().shape({
      name: yup.string().required('Facilitator name is required'),
      image: yup.mixed().default(null).nullable(),
    })
  ),
})

const teamInitialValues = {
  name: '',
  objective: '',
  teamLead: { name: '', image: null },
  facilitators: [],
}

export { teamInitialValues, teamValidationSchema }
